import copy from "copy-to-clipboard"

class Insight {
  constructor() {
    if (document.querySelector(".single-insight")) {
      this.Insight()
    }
  }

  Insight() {
    const btn = document.querySelector(".insightsMain__shareBtnCopy")
    const origMarkup = '<i class="fas fa-link" aria-hidden="true"></i>'

    btn.addEventListener("click", () => {
      if (btn.classList.contains("busy")) return
      btn.classList.add("busy")

      const url = btn.getAttribute("data-target")
      copy(url)

      btn.classList.add("copied")

      setTimeout(() => {
        btn.innerHTML = origMarkup
        btn.classList.remove("copied")
        btn.classList.remove("busy")
      }, 3500)

      setTimeout(() => {
        btn.innerHTML = "<span>Copied!</span>"
      }, 300)
    })
  }
}

export default Insight
